<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>
    <template v-if="loaded">
      <div class="content">
        <h1>
          Notifikace
        </h1>

        <v-layout>
          <v-dialog v-model="dialogDate" persistent>
            <v-card>
              <v-card-title class="headline">Den</v-card-title>
              <v-date-picker
                v-model="date"
                locale="cs-cz"
                @click:date="dialogDate = false"
              ></v-date-picker>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="empty"
                  class="button--dialog"
                  @click="dialogDate = false"
                >
                  zrušit
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogTime" persistent>
            <v-card class="text-center">
              <v-card-title class="headline">Čas</v-card-title>
              <v-time-picker
                v-model="time"
                type="month"
                class="text-center"
              ></v-time-picker>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="empty"
                  class="button--dialog"
                  @click="dialogTime = false"
                >
                  Zavřít
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <table class="info-table">
            <tr>
              <td class="info-table__title">
                <v-checkbox
                  disabled
                  label="Plánovaná"
                  class="input--smaller"
                  outlined
                  v-model="data.is_planned"
                />
              </td>
              <td class="info-table__value"></td>
            </tr>
            <tr v-if="data.is_planned">
              <td class="info-table__title">
                <v-btn
                  color="secondary"
                  class="button-top control mr-1"
                  @click="dialogDate = true"
                  >Den</v-btn
                >
                <v-btn
                  color="secondary"
                  class="button-top control"
                  @click="dialogTime = true"
                  >Čas</v-btn
                >
              </td>
              <td class="info-table__value" style="vertical-align:middle">
                {{ date }} {{ time }}
              </td>
            </tr>
            <tr>
              <td class="info-table__title">
                Titulek:
              </td>
              <td class="info-table__value">
                <v-text-field
                  class="input--small"
                  outlined
                  @input="errors.name = ''"
                  v-model="data.title"
                  :error-messages="makeError(errors.name)"
                >
                </v-text-field>
              </td>
            </tr>
            <tr>
              <td class="info-table__title">
                Obsah:
              </td>
              <td class="info-table__value">
                <tiptap-vuetify
                  class="wysiwyg"
                  v-bind:class="{ 'wysiwyg--error': errors.content }"
                  @input="errors.content = ''"
                  v-model="data.content"
                  :extensions="extensions"
                />
              </td>
            </tr>

            <tr>
              <td class="info-table__title">
                Typ notifikace:
              </td>
              <td class="info-table__value">
                <v-select
                  v-model="data.attributes.type"
                  :items="notificationTypes"
                  item-value="value"
                  item-text="name"
                  outlined
                  class="input--small"
                />
              </td>
            </tr>

            <tr>
              <td class="info-table__title">
                Text tlačítka:
              </td>
              <td class="info-table__value">
                <v-text-field
                  class="input--small"
                  outlined
                  @input="errors.text = ''"
                  v-model="data.attributes.text"
                  :error-messages="makeError(errors.text)"
                >
                </v-text-field>
              </td>
            </tr>
            <tr v-if="data.attributes.type === 'BUTTON_URL'">
              <td class="info-table__title">
                Odkaz na web:
              </td>
              <td class="info-table__value">
                <v-text-field
                  class="input--small"
                  outlined
                  @input="errors.text = ''"
                  v-model="data.attributes.target"
                  :error-messages="makeError(errors.target)"
                >
                </v-text-field>
              </td>
            </tr>
            <tr v-if="data.attributes.type === 'BUTTON_APP'">
              <td class="info-table__title">
                Odkaz na knihu v aplikaci:
              </td>
              <td class="info-table__value">
                <v-autocomplete
                  class="input--small"
                  v-model="data.attributes.target"
                  :items="
                    audiobooks.filter(
                      (a) => a.published == 1 && !a.is_ebook && !a.is_book
                    )
                  "
                  item-value="id"
                  item-text="name"
                  outlined
                />
              </td>
            </tr>

            <tr v-if="image && imageUploaded">
              <td class="info-table__title"></td>
              <td class="info-table__value">
                <v-img
                  :src="image"
                  contain
                  max-width="150"
                  max-height="150"
                  class="ml-auto"
                />
              </td>
            </tr>
            <tr v-if="image && !imageUploaded">
              <td class="info-table__title"></td>
              <td class="info-table__value text-right">
                <div
                  class="image image--loader"
                  style="max-width: 150px;max-height: 150px;text-align: right;margin-left: auto;"
                >
                  <div class="loader">
                    <div class="loader__item"></div>
                    <div class="loader__text">Nahrávání</div>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td class="info-table__title"></td>
              <td class="info-table__value text-right">
                <input
                  type="file"
                  accept="image/jpg, image/jpeg, image/png, image/webp"
                  class="d-none"
                  ref="uploadNotificationImage"
                  @input="uploadNotificationImage($event.target.files[0])"
                />
                <v-btn
                  class="button--inputs"
                  color="primary"
                  @click="$refs.uploadNotificationImage.click()"
                >
                  Nahrát obrázek
                </v-btn>
              </td>
            </tr>
          </table>
        </v-layout>

        <v-layout>
          <div class="controls-table">
            <v-btn
              color="primary"
              type="submit"
              class="button--control"
              @click="store"
            >
              Uložit
            </v-btn>
          </div>
        </v-layout>

        <v-snackbar v-model="snackbar">
          {{ snackText }}

          <template v-slot:action="{ attrs }">
            <v-btn color="error" text v-bind="attrs" @click="snackbar = false">
              Zavřít
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </template>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {Bold, BulletList, HardBreak, Heading, History, Italic, Link, ListItem, OrderedList, Paragraph, Strike, TiptapVuetify, Underline,} from 'tiptap-vuetify';

export default {
  components: {
    TiptapVuetify,
  },
  data() {
    return {
      dialogDate: false,
      dialogTime: false,
      imageUploaded: false,
      notificationTypes: [
        {
          value: 'BUTTON_APP',
          name: 'Odkaz na knihu v aplikaci',
        },
        {
          value: 'BUTTON_URL',
          name: 'Odkaz na web',
        },
      ],
      snackbar: false,
      snackText: null,
      image: null,
      imagePath: null,
      audiobooks: [],
      loaded: false,
      date: null,
      time: null,
      data: {
        title: '',
        content: '',
        image: null,
        is_planned: 0,
        time: null,
        attributes: {
          type: 'BUTTON_URL',
          text: '',
          target: '',
        },
      },
      errors: {},
      extensions: [
        History,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [2, 3],
            },
          },
        ],
        Bold,
        Paragraph,
        HardBreak,
      ],
    };
  },

  async created() {
    this.fetchAudiobooks();
    await this.show(this.$route.params.id);
  },
  computed: {
    ...mapState(['profile']),
  },
  mounted() {},
  methods: {
    async show(id) {
      try {
        this.loaded = false;
        const { data } = await this.$axios.get(`/notifications/admin/${id}`);
        console.log(data.data);
        this.data = data.data;
        this.date = this.data.day
        this.time = this.data.hour
        this.image = this.data.full_image_path
        this.imageUploaded = true
        this.loaded = true;
      } catch (error) {
        console.error(error);
      }
    },
    async store() {
      try {
        (this.snackbar = false), (this.snackText = null);
        this.loaded = false;
        if (this.data.is_planned && this.date && this.time)
          this.data.time = this.date + ' ' + this.time;
        await this.$axios.put('/notifications/admin/' + this.data.id, this.data);
        this.loaded = true;
        this.$router.push({ name: 'Notifications' });
      } catch (error) {
        this.loaded = true;
        console.error(error);
        if (error.response) {
          this.snackText = error.response.data.error.description;
          this.snackbar = true;
        }
      }
    },
    async uploadNotificationImage(f) {
      try {
        this.imageUploaded = false;
        this.image = URL.createObjectURL(f);
        let file = new FormData();
        file.append('image', f);
        const { data } = await this.$axios.post(
          '/notifications/admin/image',
          file,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }
        );
        this.data.image = data.data.path;
        this.imageUploaded = true;
      } catch (error) {
        console.error(error);
        this.imageUploaded = true;
      }
    },
    makeError(item) {
      if (item === 'required') {
        return 'Toto pole je povinné';
      } else if (item === 'already_used') {
        return 'Je již používaný';
      } else if (item === 'not_valid') {
        return 'Neplatný formát';
      } else if (item) {
        return 'Neznámá chyba';
      } else {
        return '';
      }
    },
    fetchAudiobooks() {
      this.$axios
        .get('/admin/audiobooks', {params: {pagination: 0, sortBy: 'name', order: 'ASC'}})
        .then((response) => {
          this.audiobooks = response.data.audiobooks;
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
